/* eslint-disable react/destructuring-assignment */
import React, { ReactNode, useCallback, useRef } from 'react';

import { useCustomEventListener } from '@/hooks/useCustomEventListener/useCustomEventListener';

interface ICardBaseProps {
  onClick?: () => void;
  clickable?: boolean;
  children: ReactNode;
}

interface ICardContainerProps extends ICardBaseProps {
  appearance: 'container' | 'outline';
}

interface ICardImageProps extends ICardBaseProps {
  appearance: 'image';
  alt?: string;
  src: string;
  orientation?: 'vertical' | 'horizontal';
  dataAriaLabel?: string;
}

interface ICardImageFullProps extends ICardBaseProps {
  appearance: 'imageFull';
  alt?: string;
  src: string;
}

type TCardProps = ICardContainerProps | ICardImageProps | ICardImageFullProps;

export default function Card(props: TCardProps) {
  const cardRef = useRef<HTMLDivElement>(null);

  const { onClick } = props;

  const handleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);

  useCustomEventListener(cardRef, 'tgrclick', handleClick);

  if (props.appearance === 'container') {
    return (
      <tgr-card-container ref={cardRef} clickable={props.clickable}>
        {props.children}
      </tgr-card-container>
    );
  }

  if (props.appearance === 'outline') {
    return (
      <tgr-card-outline ref={cardRef} clickable={props.clickable || undefined}>
        {props.children}
      </tgr-card-outline>
    );
  }

  if (props.appearance === 'image') {
    return (
      <tgr-card-image
        ref={cardRef}
        src={props.src}
        alt={props.alt}
        orientation={props.orientation}
        clickable={props.clickable || undefined}
        dataAriaLabel={props.dataAriaLabel}
      >
        {props.children}
      </tgr-card-image>
    );
  }

  if (props.appearance === 'imageFull') {
    return (
      <tgr-card-image-full
        ref={cardRef}
        src={props.src}
        clickable={props.clickable || undefined}
      >
        {props.children}
      </tgr-card-image-full>
    );
  }

  return null;
}
